import React, { Component } from 'react'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import LPTestimonialCard from './LPTestimonialCard'
import { Arrow, Container, SliderContainer, LeftArrow, RightArrow } from './styles'

export default class LPCarousel extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }

  next() {
    this.slider.slickNext()
  }

  previous() {
    this.slider.slickPrev()
  }

  render() {
    const { testimonials } = this.props
    const displayTestimonials = testimonials || []

    return (
      <SliderContainer>
        <LeftArrow onClick={this.previous}>
          <Arrow
            src="https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2Fb96abc462a18494a8a1dc4a51a8d5102"
            alt="Forward Arrow"
          />
        </LeftArrow>
        <Slider
          ref={(c) => (this.slider = c)}
          className="center"
          centerMode
          infinite
          centerPadding="250px"
          slidesToShow={1}
          speed={500}
          slidesToScroll={1}
          initialSlide={0}
          dots
          arrows
          responsive={[
            {
              breakpoint: 1100,
              settings: {
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '200px',
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '150px',
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 740,
              settings: {
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '100px',
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 450,
              settings: {
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
              },
            },
          ]}
        >
          {displayTestimonials.map((review, i) => {
            const { title, text, image, name, location, household, starRating, useStars } = review
            return (
              <React.Fragment key={i}>
                <Container>
                  <LPTestimonialCard
                    title={title}
                    text={text}
                    image={image}
                    name={name}
                    location={location}
                    household={household}
                    useStars={useStars}
                    starRating={starRating}
                  />
                </Container>
              </React.Fragment>
            )
          })}
        </Slider>
        <RightArrow onClick={this.next}>
          <Arrow
            src="https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F154fb2f4675d47489c0a4b045de6393f"
            alt="Forward Arrow"
          />
        </RightArrow>
      </SliderContainer>
    )
  }
}

LPCarousel.propTypes = {
  testimonials: PropTypes.array,
}
